import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PrivateRoute from './components/private-route/private-route';
import Login from './components/login/login';
import FlightListOptions from './components/flight-list-options/flight-list-options';
import FlightSearch from './components/flight/flightSearch';
import FlightList from './components/flight-list/flight-list';
import Flight from './components/flight/flight';
import Aircraft from './components/master-data/aircraft';
import AircraftMap from './components/master-data/aircraft-map';
import Closures from './components/master-data/closures';
import Alternates from './components/master-data/alternates';
import EFB from './components/master-data/efb';
import MelCdl from './components/master-data/melcdl';
import WorkAllocation from './components/master-data/workAllocation';
import Permits from './components/master-data/permits';
import Tankering from './components/master-data/tankering';
import './App.css';
import flightSearch from './components/flight/flightSearch';
import Disable from './components/typeahead/typeahead';




const App = _ => {
  const baseRoute = '/eff'

  return (
    <div className='App text-light d-flex flex-column overflow-hidden'>

        <Switch>
          <Route
            // path={`${baseRoute}/login`}
            path='/login'
            component={Login}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/flightlistoptions`}
            path='/flightlistoptions'
            component={FlightListOptions}
            exact={true}
          />
          <PrivateRoute
            path='/flightsearch'
            component={flightSearch}
            exact={true}
          />
          <PrivateRoute
            path='/flights'
            component={FlightList}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/flights/:id'`}
            path='/flights/:id'
            component={Flight}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/tankering`}
            path='/tankering'
            component={Tankering}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/closures`}
            path='/closures'
            component={Closures}
            exact={true}
          />
          <PrivateRoute
            path='/alternates'
            component={Alternates}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/aircraft`}
            path='/aircraft'
            component={Aircraft}
            exact={true}
          />
          <PrivateRoute
            //  path={`${baseRoute}/aircraftmap`}
            path='/aircraftmap'
            component={AircraftMap}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/permits`}
            path='/permits'
            component={Permits}
            exact={true}
          />
          <PrivateRoute
            path='/efb'
            component={EFB}
            exact={true}
          />
          <PrivateRoute
            // path={`${baseRoute}/melcdl`}
            path='/melcdl'
            component={MelCdl}
            exact={true}
          />
          <PrivateRoute
            path='/workallocation'
            component={WorkAllocation}
            exact={true}
          />
          <Route render={
            _ => <Redirect to={{
              pathname: '/login'
            }} />
          } />
        </Switch>
    </div>
  );
}

export default App;
